import { useCUTranslate } from '../../CUTranslation/hooks/useCUTranslate';
import { useControlUnitById } from '../../controlUnit/hooks/useControlUnitById';
import { useAppSelector } from '../../store.model';
import {
  getCUParametersComposedFromControlUnit,
  getErrorCUParametersFromControlUnit,
  getLoadingCUParametersFromControlUnit,
} from '../selectors';
import { ParametersAPI } from '../api/ParametersAPI';

export function useCUParameters(props: {
  deviceId: string;
  controlUnitId: string;
}) {
  const { deviceId, controlUnitId } = props;
  const { isLoading: isLoadingCuTranslate } = useCUTranslate(deviceId);
  const { isLoading: isLoadingControlUnit, error: errorControlUnits } =
    useControlUnitById(deviceId, controlUnitId);

  const composedParameters = useAppSelector((state) =>
    getCUParametersComposedFromControlUnit(state, {
      deviceId,
      controlUnitId,
    })
  );

  const loading = useAppSelector((state) =>
    getLoadingCUParametersFromControlUnit(state, {
      deviceId,
      controlUnitId,
    })
  );

  const error = useAppSelector((state) =>
    getErrorCUParametersFromControlUnit(state, {
      deviceId,
      controlUnitId,
    })
  );

  const { isLoading: isLoadingCUParameters, error: errorCUParameters } =
    ParametersAPI.useGetCUParametersFromCUQuery({
      deviceId,
      controlUnitId,
    });

  return {
    composedParameters,
    loading:
      loading ||
      isLoadingControlUnit ||
      isLoadingCuTranslate ||
      isLoadingCUParameters,
    error: error || errorControlUnits || errorCUParameters,
  };
}
